import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Button } from '@dojo/widgets/button';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import css from '../css/tools-button.m.css';
const factory = create({
    theme
}).properties();
export const MicroToolsButton = factory(({ id, properties, middleware: { theme } }) => {
    const { labelText = '', aria = {}, disabled = false, name, onBlur, onClick, onDown, onFocus, widgetId = `button-${id}`, title = '', darkMode = false } = properties();
    const fixedCss = theme.classes(css);
    const label = v('span', {}, [labelText]);
    const overrides = {
        '@dojo/widgets/button': {
            root: [fixedCss.root],
            text: [fixedCss.text],
            contained: [fixedCss.contained],
            outlined: [fixedCss.outlined],
            popup: [fixedCss.popup],
            label: [fixedCss.label],
            icon: [fixedCss.icon],
            iconOnly: [fixedCss.iconOnly],
            disabled: [fixedCss.disabled]
        }
    };
    return v('div', { classes: [darkMode ? fixedCss.dark : null] }, [
        w(Button, {
            classes: overrides,
            ...formatAriaProperties(aria),
            disabled,
            name,
            onBlur,
            onClick,
            onDown,
            onFocus,
            widgetId,
            title,
            kind: 'outlined'
        }, [
            {
                label
            }
        ])
    ]);
});
export default MicroToolsButton;
